export enum OrderStatus {
  CONFIRMED = 'confirmed',
  FAILED = 'failed',
  REFUND_INITIATED = 'refund_initiated',
  REFUND_CONFIRMED = 'refund_confirmed',
  REFUND_FAILED = 'refund_failed'
}

export enum TransactionStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  INITIATED = 'initiated'
}
